import { UNIT_FACTOR_WATT_TO_WATTHOUR } from 'src/Configuration/defaults'
import { WallboxConfigurationDto } from 'src/Libs/wallboxes/api'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes/models'

/**
 * Transform WallboxConfigurationModel to WallboxConfigurationDto
 */
const fromSettingsModelToDtoTransformer = (model: Partial<WallboxConfigurationModel>): Partial<WallboxConfigurationDto> => ({
  /* activeChargeStrategy used only in software version < X_2024_04 */
  activeChargeStrategy: model.activeChargeStrategy,

  authRequired: model.authRequired,
  autoPhaseSwitchEnabled: model.autoPhaseSwitchEnabled,
  bidiModeActive: model.bidiModeActive,
  bidiShiftModeSocRange: model.bidiShiftModeSocRange && {
    paramBidiShiftModeStartSoc: model.bidiShiftModeSocRange.paramBidiShiftModeStartSoc,
    paramBidiShiftModeEndSoc: model.bidiShiftModeSocRange.paramBidiShiftModeEndSoc,
  },
  chargeFull: model.isBoostModeActive,
  chargeStopHysteresis: model.chargeStopHysteresis,
  ledIntensity: model.ledIntensity,
  cableLock: model.cableLock,

  /* chargeStrategy, chargeStrategyConfiguration used only in software version >= X_2024_04 */
  chargeStrategy: model.chargeStrategy,
  chargeStrategyConfiguration: model.chargeStrategyConfiguration,

  deviceName: model.deviceName,
  deviceState: model?.deviceState && {
    deviceConnected: model.deviceState?.connected,
    deviceWorking: model.deviceState?.working,
    deviceInService: model.deviceState?.inService,
  },
  dhcpEnabled: model.dhcpEnabled,
  diagBatCapacity: model.diagBatCapacity !== undefined ? Number(model.diagBatCapacity) * UNIT_FACTOR_WATT_TO_WATTHOUR : undefined,
  gateway: model.gateway,
  index: model.listIndex,
  ipAddr: model.ipAddr,
  keyLockMode: model.keyLockMode,
  lowerCurrentLimit: model.lowerCurrentLimit,
  maxChargeCurrent: model.maxChargeCurrent,
  maxPowerPerPhase: model.maxPowerPerPhase,
  minChargeCurrent: model.minChargeCurrent,
  minChargePower: model.minChargePower,
  maxChargePower: model.maxChargePower,
  maxDischargePower: model.maxDischargePower,
  minPowerPerPhase: model.minPowerPerPhase,
  numberPhases: model.numberPhases,

  /* parameterList used only in software version < X_2024_04 */
  parameterList: model.weekdays,

  pmEnergyL1: model.pmEnergyL1,
  pmEnergyL2: model.pmEnergyL2,
  pmEnergyL3: model.pmEnergyL3,
  pmPowerL1: model.pmPowerL1,
  pmPowerL2: model.pmPowerL2,
  pmPowerL3: model.pmPowerL3,
  rfidReaderEnabled: model.rfidReaderEnabled,
  subnetMask: model.subnetMask,
  sunModeActive: model.sunModeActive,
  upperCurrentLimit: model.upperCurrentLimit,
  wallboxType: model.wallboxType,
})

export default fromSettingsModelToDtoTransformer
